import { SettingOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  IStepCompetitionConfigFormValues,
  StepOrderTypes,
} from "../../../Interfaces/stepInterfaces";
import Modal from "../../../Components/Modal/Modal";
import ModalUI from "./ModalUI";
import { setStepCompetitionConfigFormValues } from "../../../Features/Step/stepSlice";

const CompetitionOrderConfig = () => {
  const [isOpen, setIsOpen] = useState(false);
  const operationType = useAppSelector((store) => store.step.operationType);

  const dispatch = useAppDispatch();
  const modalCloseHandler = () => {
    setIsOpen(false);
    dispatch(
      setStepCompetitionConfigFormValues({} as IStepCompetitionConfigFormValues)
    );
  };

  if (operationType === StepOrderTypes.Competition)
    return (
      <>
        <div
          className="flex flex-row justify-start items-center w-full gap-3 p-2 border-2 rounded border-gray-300 hover:border-gray-500 transition-all duration-200 cursor-pointer"
          onClick={() => setIsOpen(true)}
        >
          {isOpen ? (
            <Modal UI={<ModalUI />} onClose={modalCloseHandler} />
          ) : (
            <></>
          )}
          <SettingOutlined />
          <div className="text-xs">تنظیمات کمین</div>
        </div>
      </>
    );
  return <></>;
};

export default CompetitionOrderConfig;
